<template>
    <ul class="menu-nav">
        <!--
        <router-link
            to="/my_greetings/my_greetings-form"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                    isActive && 'menu-item-active',
                    isExactActive && 'menu-item-active'
                ]"
            >
                <a :href="href" class="menu-link" @click="navigate">
                    <span class="menu-text">Teşekkür Et </span>
                </a>
            </li>
        </router-link>

        <router-link
            to="/incoming_greetings"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                    isActive && 'menu-item-active',
                    isExactActive && 'menu-item-active'
                ]"
            >
                <a :href="href" class="menu-link" @click="navigate">
                    <span class="menu-text"> Bana Gelen Mesajlar </span>
                </a>
            </li>
        </router-link>

        <router-link
            to="/greeting_stats"
            v-slot="{ href, navigate, isActive, isExactActive }"
        >
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[
                    isActive && 'menu-item-active',
                    isExactActive && 'menu-item-active'
                ]"
            >
                <a :href="href" class="menu-link" @click="navigate">
                    <span class="menu-text"> Genel İstatistikler </span>
                </a>
            </li>
        </router-link>
        -->
        
    </ul>
</template>

<script>
export default {
    name: "KTMenu",
    methods: {
        hasActiveChildren(match) {
            return this.$route["path"].indexOf(match) !== -1;
        }
    }
};
</script>
